// Figma: RGM Landing Page > Navbar V2 rail > navigation menu.
// `assets/svg/Menu.tsx` draws the same 3x3 grid but hardcodes its stroke, so it cannot
// take the rail's active/inactive colour.
const GridDots = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <circle cx="5.5" cy="5.5" r="1.35" />
        <circle cx="10" cy="5.5" r="1.35" />
        <circle cx="14.5" cy="5.5" r="1.35" />
        <circle cx="5.5" cy="10" r="1.35" />
        <circle cx="10" cy="10" r="1.35" />
        <circle cx="14.5" cy="10" r="1.35" />
        <circle cx="5.5" cy="14.5" r="1.35" />
        <circle cx="10" cy="14.5" r="1.35" />
        <circle cx="14.5" cy="14.5" r="1.35" />
    </svg>
);

export default GridDots;
